import { render, staticRenderFns } from "./QuizLessonEdit.vue?vue&type=template&id=39f3d43c&scoped=true&"
import script from "./QuizLessonEdit.vue?vue&type=script&lang=ts&"
export * from "./QuizLessonEdit.vue?vue&type=script&lang=ts&"
import style0 from "./QuizLessonEdit.vue?vue&type=style&index=0&id=39f3d43c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f3d43c",
  null
  
)

export default component.exports